/** Widget events are hints; only backend reconciliation establishes settlement. */
export function applyHostedWidgetEvent(event) {
    switch (event.kind) {
        case 'ready':
            return { phase: 'ready' };
        case 'transactionCreated':
            return { phase: 'transaction_created', transactionId: event.payload.transaction.id };
        case 'complete':
            return event.payload.transaction.id
                ? { phase: 'reconciling', transactionId: event.payload.transaction.id }
                : { phase: 'provider_failed' };
        case 'close':
            return { phase: 'widget_closed' };
        case 'error':
            return { phase: 'provider_failed' };
    }
}
